var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-profile-personal"},[_c('ui-infolist',{attrs:{"info":_vm.info}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }